import React from 'react';
import Login from '../../pages/login'
import { Logout } from './Logout'
import { ApplicationPaths, LoginActions, LogoutActions } from './ApiAuthorizationConstants';
import { useLocation } from 'react-router-dom';

function LoginRoute({ action }) {
    const location = useLocation();

    // key changes when querystring changes => Login remounts => componentDidMount runs again
    const key = `${action}:${location.pathname}:${location.search}`;

    return <Login key={key} action={action} />;
}

function LogoutRoute({ action }) {
    const location = useLocation();
    const key = `${action}:${location.pathname}:${location.search}`;
    return <Logout key={key} action={action} />;
}

const ApiAuthorizationRoutes = [
    { path: ApplicationPaths.Login, element: <LoginRoute action={LoginActions.Login} /> },
    { path: ApplicationPaths.LoginFailed, element: <LoginRoute action={LoginActions.LoginFailed} /> },
    { path: ApplicationPaths.LoginCallback, element: <LoginRoute action={LoginActions.LoginCallback} /> },
    { path: ApplicationPaths.Profile, element: <LoginRoute action={LoginActions.Profile} /> },
    { path: ApplicationPaths.Register, element: <LoginRoute action={LoginActions.Register} /> },

    { path: ApplicationPaths.LogOut, element: <LogoutRoute action={LogoutActions.Logout} /> },
    { path: ApplicationPaths.LogOutCallback, element: <LogoutRoute action={LogoutActions.LogoutCallback} /> },
    { path: ApplicationPaths.LoggedOut, element: <LogoutRoute action={LogoutActions.LoggedOut} /> }
];

export default ApiAuthorizationRoutes;
